
import React from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useProfilePrivacy } from "@/hooks/useProfilePrivacy";

const SimplePrivacyToggle = () => {
  const { isPrivate, isLoading, isUpdating, updatePrivacySetting } = useProfilePrivacy();

  const handlePrivacyToggle = async (checked: boolean) => {
    await updatePrivacySetting(checked);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-2">
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between">
      <Label htmlFor="privacy-toggle" className="text-sm font-medium cursor-pointer">
        Private
      </Label>
      <Switch
        id="privacy-toggle"
        checked={isPrivate}
        onCheckedChange={handlePrivacyToggle}
        disabled={isUpdating}
      />
    </div>
  );
};

export default SimplePrivacyToggle;
